import { render, staticRenderFns } from "./NewRegistrationForm.vue?vue&type=template&id=12d94716&scoped=true&"
import script from "./NewRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./NewRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d94716",
  null
  
)

export default component.exports